import { useEffect } from "react"

const PING_INTERVAL_MS = 10 * 60 * 1000 // 10 minutes

/**
 * Silently pings the Better Auth session endpoint at a fixed interval while
 * the tab is visible. Each ping resets the server-side session expiry (Better
 * Auth extends the session whenever it's accessed within the updateAge window),
 * so users who stay on the page never get logged out mid-session.
 */
export function useSessionKeepalive() {
  useEffect(() => {
    async function ping() {
      if (document.visibilityState !== "visible") return
      try {
        await fetch("/api/auth/get-session", { credentials: "include" })
      } catch {
        // network error — ignore, query cache will handle auth failures
      }
    }

    const id = setInterval(ping, PING_INTERVAL_MS)
    return () => clearInterval(id)
  }, [])
}
